import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField from '@mui/material/TextField';
import { useLanguage } from '../../Services/LanguageContext';

interface IProps {
    onChange: any;
    value: string;
}

const PasswordField = (props: IProps) => {
    const [showPassword, setShowPassword] = useState(false);
    const { t } = useLanguage();

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <TextField
            id='outlined-password-input'
            label={t('password')}
            type={showPassword ? 'text' : 'password'}
            autoComplete='current-password'
            variant='outlined'
            onChange={(x) => {
                props.onChange(x.target.value);
            }}
            value={props.value}
            fullWidth
            InputLabelProps={{
                shrink: true,
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                    background: 'var(--bg-tertiary)',
                },
                '& .MuiInputAdornment-root': {
                    marginLeft: '0px',
                },
            }}
            InputProps={{
                endAdornment: (
                    <IconButton
                        aria-label='toggle password visibility'
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge='end'
                        sx={{
                            padding: '8px',
                            marginRight: '-4px',
                            color: 'var(--text-secondary)',
                            '&:hover': {
                                color: 'var(--accent-cyan)',
                                backgroundColor: 'transparent',
                            },
                            '& .MuiSvgIcon-root': {
                                fontSize: '20px',
                            },
                        }}
                    >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                ),
            }}
        />
    );
};

export default PasswordField;
